export default function saveByteArray(reportName, blob) {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  const fileName = reportName;
  link.download = fileName;
  link.click();
}



// WEBPACK FOOTER //
// ./src/util/saveByteArray.ts